window.addEventListener("load", () => {
    if (!window.location.href.includes("products")) { return }
    if (!document.querySelector(".pair_single_selector__btn_wrap")) { return }
    document.querySelectorAll(".pair_single_selector__btn_wrap .button").forEach(btn => {
        btn.addEventListener("click", toggleEarringQuantity)
    })
})

function toggleEarringQuantity() {
    document.querySelectorAll(".pair_single_selector__btn_wrap .button").forEach(btn => {
        btn.classList.toggle("selected")
    })
    const quantity = document.querySelector(".pair_single_selector__btn_wrap .button.selected").dataset.quantity;
    document.querySelectorAll('input[name="items[0][quantity]"').forEach(input => input.value = quantity);
    document.querySelectorAll('quantity-selector input').forEach(input => input.value = quantity);

    if (parseInt(quantity) > 1) {
        document.querySelectorAll("[data-single-price]").forEach(singlePrice => singlePrice.classList.add("d-none"));
        document.querySelectorAll("[data-pair-price]").forEach(singlePrice => singlePrice.classList.remove("d-none"));
    } else {
        document.querySelectorAll("[data-single-price]").forEach(singlePrice => singlePrice.classList.remove("d-none"));
        document.querySelectorAll("[data-pair-price]").forEach(singlePrice => singlePrice.classList.add("d-none"));
    }
}